var React                   = require('react'),
    ReactDOM                = require('react-dom'),
    RegisterContainer       = require('../components/RegisterContainer/RegisterContainer');

import _ from 'lodash';

ReactDOM.render(
    <RegisterContainer  app={ _.get(window, 'app', '') }
                        first_name={ window.redirectedParams.first_name || '' }
                        last_name={ window.redirectedParams.last_name || '' }
                        email={ window.redirectedParams.email || '' }
                        domain_redirected={ window.redirectedParams.domain_redirected || '' }
    />,
    document.getElementById('register-wrap')
);


// WEBPACK FOOTER //
// ./auth/pages/register.js